import commonGetters from '@/store/data/common/getters'

export default commonGetters
